import React from 'react';
import { useParams } from 'react-router-dom';
import { Languages } from '~/constants/enums';

const Toggle = ({
  open,
  onChange,
}: {
  open: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}) => {
  const { locale } = useParams();

  return (
    <label className=" relative inline-flex cursor-pointer select-none items-center">
      <input
        type="checkbox"
        name="autoSaver"
        className="sr-only"
        checked={open}
        onChange={onChange}
      />
      <span
        className={` flex h-[18px] w-[32px] items-center rounded-full p-1 duration-200 ${
          open ? 'bg-blue' : 'bg-[#e0e0e0]'
        }`}
      >
        <span
          className={`h-[16px] w-[16px] rounded-full bg-white duration-200 ${
            open
              ? `${locale === Languages.ARABIC ? '-translate-x-[11px]' : 'translate-x-[11px]'}`
              : `${locale === Languages.ARABIC ? 'translate-x-[3px]' : '-translate-x-[3px]'}`
          }`}
        ></span>
      </span>
    </label>
  );
};

export default Toggle;
